import React, { useState,useEffect} from 'react'
import "../../assets/style/eegisterProvider.css"
import TextField from '@mui/material/TextField';
import { Button } from '@mui/material';
import OTPInput, { ResendOTP } from "otp-input-react";
import { json, useNavigation } from 'react-router-dom';
import Web3 from "web3";
import Api from '../../utils/Api';
import { toast } from 'react-toastify';
import components from '../../components';
import { useNavigate,useParams } from 'react-router';
const VarifyOTP = () => {

let Navigater=  useNavigate()
const [OTP,setOTP]=useState("")
const {mode}=useParams()
const [loaderState,setloaderState]=useState()

 
const reSendOtp=async()=>{
     try {
          let  otpemail=localStorage.getItem("otpemail")
          const data=await Api.Api.post("/user/resendOTP",{
               "email": otpemail
           })
           console.log("🚀 ~ reSendOtp ~ data:", data)
           toast.success(data.data.message)
     } catch (error) {
          if(error.response){
               toast.error(error.response.data.message)
          }else{
               toast.success("Something Went Wrong!")
 
          }
     }
}
const onSubmit=async()=>{
     try {
                 console.log("🚀 ~ file: varifyOTP.js:16 ~ VarifyOTP ~ OTP:", JSON.parse(OTP))
               let  otpemail=localStorage.getItem("otpemail")
               let  role=localStorage.getItem("otprole")
               console.log("🚀 ~ onSubmit ~ role:", role)
               const data=await Api.Api.post("/user/verifyOTP",{
                    "email":otpemail,
                    "otp":JSON.parse(OTP)
                    })
                 
                 toast.success(data.data.message)
                 
                 // After successful OTP verification, automatically log the user in
                 if (data.data.success && data.data.token) {
                   // Store authentication data in localStorage
                   localStorage.setItem("userData", data.data.token);
                   localStorage.setItem("name", data.data.user?.institutionName || `${data.data.user?.firstName} ${data.data.user?.lastName}`);
                   localStorage.setItem("role", data.data.user?.role || role);
                   localStorage.setItem("status", data.data.user?.status);
                   localStorage.setItem("image", data.data.user?.profileImage);
                   localStorage.setItem("id", data.data.user?._id);
                   
                   // Clear OTP-related localStorage items
                   localStorage.removeItem("otpemail");
                   localStorage.removeItem("otprole");
                   
                   // Navigate to appropriate dashboard based on role
                   if (data.data.user?.role === "provider") {
                     Navigater("/admin-panel/ProviderProfile");
                   } else if (data.data.user?.role === "Fund Subscriber") {
                     Navigater("/admin-panel/BuyFundAssets");
                   } else if (data.data.user?.role === "admin") {
                     Navigater("/admin-panel/Dashboard");
                   } else {
                     // For any other role, redirect to login instead of dashboard
                     Navigater("/auth/Login");
                   }
                 } else {
                   // If no token returned, redirect to login as before
                   if(!mode){
                      Navigater("/auth/Login")  
                   }else{
                      Navigater("/auth/resetPassword")  
                   }
                 }
          
                    
        
       
     } catch (error) {
          if(error.response){
               toast.error(error.response.data.message)

          }else{
               toast.success("Something Went Wrong!")
 
          }
     }
  

}
  return (
     <div style={{ display:"flex",justifyContent:"center",marginTop:"10%", width: "100%", backgroundColor: "#F3F4F8" }}>
     <components.Loader.Back_Drop state={loaderState}/>
          
       <div     style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          width:"50%"
        }}>      <span className='Loginheading'>
                    Verify OTP 
            </span>
            <div className='LoginScreen'>
               
            <div style={{display:"flex",flexDirection:"column",height:100,justifyContent:"space-evenly"}}>
                      <div style={{display:"flex",justifyContent:"center",marginTop:10}}>
                          <span style={{width:"90%", fontFamily: 'Manrope, sans-serif'}}>Enter Your Verification OTP</span>
                      </div>
                        <div style={{display:"flex",justifyContent:"center",marginTop:10}}>


                        <OTPInput  value={OTP} onChange={(e) => {
                             console.log("🚀 ~ file: varifyOTP.js:43 ~ VarifyOTP ~ e:", e)
                             setOTP(e)
                        }} autoFocus OTPLength={6} otpType="number" disabled={false} secure />
      {/* <ResendOTP onResendClick={() => console.log("Resend clicked")} /> */}


                            {/* <input placeholder='Enter Your Provider Title' type='text' /> */}
                        </div>
                 </div>
               
                 <div style={{display:"flex",width:"90%",alignSelf:"center",justifyContent:"flex-end",paddingBottom:20}}>
                     <div style={{display:"flex",justifyContent:"space-evenly", width:"50%"}}>
                     <Button onClick={onSubmit} variant="contained">Confirm</Button>  
                     <Button onClick={reSendOtp} variant="contained">ReSend Otp</Button>  
                 </div>
                 </div>
                 

            </div>
      </div>    
    </div>
  )
}

export default VarifyOTP